module.exports = __webpack_public_path__ + "media/images/getcrowd_white-7124619b30c10de7bfbf9725efd4a5b4.png";